module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp3"
  }), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-head"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#cpyntc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epigraph#epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/photo#photo"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Photography")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/cast#cast"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Cast")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("1.  The Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.  Reni")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.  Sweden")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  So Young")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Hannett")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  Gareth")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  Mani")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.  Leckie")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.  Blackpool")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.  ‘Fools Gold’")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.  Madchester")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.  ‘One Love’")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.  Geffen")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.  Second Coming")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.  Reni II")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.  Robbie")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.  Fifteen Years")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.  Reunion")])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/afterword#aft",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Afterword")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photogr1#ph1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Photographs")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/gigography#gig",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gigography/Discography")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#nts",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#abt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-contents-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0